import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Flex,
  VStack,
  Text,
} from '@chakra-ui/react';
import { NAV_LINKS } from '../../../utils/constants';
import { IconButton } from 'src/components/atoms/IconButton';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { X, LogIn } from 'lucide-react';
import { YapamarLogo } from 'src/components/atoms/YapamarLogo';
import { Dispatch, SetStateAction } from 'react';
import { IS_DEV } from 'src/constants';
import { useNavigate } from 'react-router-dom';

interface MobileDrawerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginClick: Dispatch<SetStateAction<boolean>>;
}

const MobileDrawerMenu: React.FC<MobileDrawerMenuProps> = ({
  isOpen,
  onClose,
  onLoginClick,
}) => {
  const navigate = useNavigate();

  return (
    <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        bg="white"
        w={{ base: '100vw', md: '400px' }}
        maxW={{ base: '100vw', md: '400px' }}>
        <DrawerHeader borderBottom="1px solid #edf2f9" pb={1}>
          <Flex align="center" justify="space-between">
            <YapamarLogo theme="dark" />
            <IconButton
              icon={<ChakraIcon as={X} w={4} h={4} />}
              bg="gray.100"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              aria-label="Close menu"
              variant="ghost"
              color="gray.800"
              onClick={onClose}
            />
          </Flex>
        </DrawerHeader>
        <DrawerBody>
          <VStack align="start" spacing={8} mt={6}>
            <Text
              color="gray.800"
              fontSize="21px"
              fontWeight="medium"
              w="100%"
              onClick={onClose}
              _hover={{ color: 'green.500' }}
              fontFamily="marketingPage">
              Menu
            </Text>
            {NAV_LINKS.map((link, idx) => (
              <Text
                key={idx}
                color="gray.700"
                fontSize="16px"
                fontWeight="normal"
                fontFamily="marketingPage"
                w="100%"
                cursor={link.href !== '#' ? 'pointer' : 'default'}
                onClick={() => {
                  if (link.href !== '#') {
                    navigate(link.href);
                    onClose();
                  }
                }}
                _hover={link.href !== '#' ? { color: 'green.500' } : {}}>
                {link.label}
              </Text>
            ))}
            {IS_DEV && (
              <Flex
                align="center"
                mt={4}
                gap={2}
                cursor="pointer"
                onClick={() => onLoginClick(true)}
                _hover={{ color: 'green.500' }}>
                <ChakraIcon as={LogIn} w={5} h={5} color="gray.800" />
                <Text
                  color="gray.800"
                  fontWeight="semibold"
                  fontFamily="marketingPage"
                  fontSize="16px">
                  Log In
                </Text>
              </Flex>
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileDrawerMenu;
